import { useGetHttp } from "../../http.hook";
import type { ICSVUpload } from "./add-new-csv-favorite-collection.admin.http";

interface IResponse {
  csvLog: ICSVUpload;
}

export function useGetCsvLogByIdAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/favourite-socials/csv/:csvId",
  });
}
